import { useContext } from 'react';
import ConfigurationContext from '../Contexts/ConfigurationContext';

export const useNumberUtils = () => {

    const { configurationData } = useContext(ConfigurationContext);

    const formatLongNumber = (number) => {
        if (number == null) {
            return null;
        }

        if (configurationData?.length > 0) {
            let locale = configurationData.find(element => element.name === "Locale");
            if (locale) {
                return number.toLocaleString(locale.value);
            } else {
                console.warn("Locale not found. Add a configuration entry for 'Locale' in Configuration Data with a valid locale, e.g. en-GB");
                return number;
            }
        }
    }

    return { formatLongNumber };
}